import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getConfigSettings, getCountriesAndStatesList, getGlobalFormsList, getPrepayAmount, getScheduledDateDeadlines, getforms94xList } from "./DataLoaderSaga";
import { componentKey as authenticationComponentKey } from "../../authentication/AuthenticationSlice";
import { componentKey, setIsPrepayAmountFetched, updateDataLoadingState } from "./DataLoaderSlice";
import { PAGE_STATE } from "../../constants/constants";
import Loadable from "../../../components/loadable/Loadable"
import { DATA_LOADER_LOADING_STATES } from "./constants";

export default function DataLoader({ children }) {

    const { isUserAuthenticated, authenticationLoader } = useSelector((state) => state[authenticationComponentKey])
    const { dataLoadingState, countriesList, statesList, isPrepayAmountFetched, globalFormsNYearsList } = useSelector((state) => state[componentKey])
    const dispatch = useDispatch();

    useEffect(() => {

        if (isUserAuthenticated && (!countriesList.length || !statesList.length)) {
            dispatch(getCountriesAndStatesList());
        }

        if (isUserAuthenticated && isPrepayAmountFetched == false) {
            dispatch(setIsPrepayAmountFetched())
            dispatch(getPrepayAmount());
        }
        if (isUserAuthenticated && !globalFormsNYearsList?.Forms.length) {
            dispatch(getScheduledDateDeadlines())
            dispatch(getGlobalFormsList());
        }

        if (isUserAuthenticated) {
            dispatch(getforms94xList());
            dispatch(getConfigSettings());
        }

        if (!isUserAuthenticated && authenticationLoader.state === PAGE_STATE.PAGE_READY) {
            dispatch(updateDataLoadingState({ state: PAGE_STATE.PAGE_READY }))
        }

    }, [isUserAuthenticated, authenticationLoader])

    return <Loadable currentState={dataLoadingState.state} loadingStates={[PAGE_STATE.LOADING, PAGE_STATE.PRE_LOADING, DATA_LOADER_LOADING_STATES.GET_SCHEDULED_DATE_DEADLINES_LOADING]} isNewLoadable={true}>
        {children}
    </Loadable>;

}